// var languageType = require('./languageCommon.js')
var languageType = require('./languageCommon.js')
var language = localStorage.getItem('language') || 'zh-CN'

if(language=='zh-CN'){
    document.getElementsByTagName('meta')[1].setAttribute('content',tanchenmeta[language])
    document.getElementsByTagName('meta')[2].setAttribute('content',tanchenkey[language])
    document.title = tanchentitle[language];
}else{
    document.getElementsByTagName('meta')[1].setAttribute('content',tanchenmeta['USA'])
    document.getElementsByTagName('meta')[2].setAttribute('content',tanchenkey['USA'])
    document.title = tanchentitle['USA'];
    // document.getElementsByTagName('title')[1].setAttribute('content',grouptitle['USA'])
}

$('.commonlanguage').html(commonlanguage[language])
$('title').html(tanchenTitle[language]);
$('.commonHomePage').html(commonHomePage[language]);
$('.commonLvyue').html(commonLvyue[language]);
$('.commonAboutLvyue').html(commonAboutLvyue[language]);
$('.commonlvyueBrand').html(commonlvyueBrand[language]);
$('.commonFlowerConstruction').html(commonFlowerConstruction[language]);
$('.commonFloralLux').html(commonFloralLux[language]);
$('.commonClaim').html(commonClaim[language]);
$('.commonWeiLai').html(commonWeiLai[language]);
$('.commonTanChen').html(commonTanChen[language]);
$('.commonJoinInCooperation').html(commonJoinInCooperation[language]);
$('.commonPanorama').html(commonPanorama[language]);
// $('.commonPaidInformation').html(commonPaidInformation[language]);
$('.buftlanguage1').html(buftlanguage1[language]);
$('.decslan1').html(decslan1[language]);
$('.buftlanguage2').html(buftlanguage2[language]);
$('.decslan2').html(decslan2[language]);
$('.buftlanguage3').html(buftlanguage3[language]);
$('.decslan3').html(decslan3[language]);
$('.aruati').html(aruati[language]);

$('.tanchenDesignType1').html(tanchenDesignType1[language]);
$('.tanchenDesignType2').html(tanchenDesignType2[language]);
$('.tanchenDesignType3').html(tanchenDesignType3[language]);
$('.tanchenDesign').html(tanchenDesign[language]);

$('.tanchenBrandIntroductionTitle').html(tanchenBrandIntroductionTitle[language]);
$('.tanchenBuildingaboutfbType1').html(tanchenBuildingaboutfbType1[language]);
$('.tanchenBrandIntroductionInfo').html(tanchenBrandIntroductionInfo[language]);
$('.tanchenBuildingaboutfbType3').html(tanchenBuildingaboutfbType3[language]);

$('.acTl1').html(acTl1[language]);
$('.acDec1').html(acDec1[language]);
$('.acDF1').html(acDF1[language]);
$('.acTl2').html(acTl2[language]);
$('.acDF2').html(acDF2[language]);
$('.acTl3').html(acTl3[language]);
$('.acDF3').html(acDF3[language]);


$('.commonZh').html(commonZh[language]);
$('.commonUsa').html(commonUsa[language]);
$('.commonJp').html(commonJp[language]);
$('.commonKo').html(commonKo[language]);
$('.commonTh').html(commonTh[language]);
$('.commonYh').html(commonYh[language]);
$('.commonflowerTravel').html(commonflowerTravel[language]);
$('.commonReservations a').html(commonReservations[language]);
$('.commonClose').html(commonClose[language]);
$('.commonFreebooking').html(commonFreebooking[language]);
$('.commonDownload').html(commonDownload[language]);
$('.commonWechatSubscription').html(commonWechatSubscription[language]);
$('.commonHuazhuSubscription').html(commonHuazhuSubscription[language]);
$('.commonBrandintroductio').html(commonBrandintroductio[language]);
$('.commonWantJoin').html(commonWantJoin[language]);
$('.commonConectUs').html(commonConectUs[language]);
$('.commonCustomerServiceHotline').html(commonCustomerServiceHotline[language]);
$('.commonConectChina').html(commonCustomerServiceHotlineChina[language]);
$('.commonConectPhilippines').html(commonCustomerServiceHotlinePhilippines[language]);
$('.commonConectJapan').html(commonCustomerServiceHotlineJapan[language]);
$('.commonConectKorea').html(commonCustomerServiceHotlineKorea[language]);
$('.commonConectThailand').html(commonCustomerServiceHotlineThailand[language]);
$('.commonConectYh').html(commonCustomerServiceHotlineYh[language]);
$('.commonCompanyInfo').html(commonCompanyInfo[language]);
$('.commonCompanyBeianInfo').html(commonCompanyBeianInfo[language]);
$('.commonCompanyBeianText').html(commonCompanyBeianText[language]);
$('.commonCompanyLicense').html(commonCompanyLicense[language]);
$('.commonCompanyICP').html(commonCompanyICP[language]);
$('.WeiLaiDesign').html(WeiLaiDesign[language]);
$('.WeiLaiDesignType1').html(WeiLaiDesignType1[language]);
$('.WeiLaiDesignType2').html(WeiLaiDesignType2[language]);
$('.WeiLaiDesignType3').html(WeiLaiDesignType3[language]);
$('.WeiLaiBrandIntroductionTitle').html(WeiLaiBrandIntroductionTitle[language]);
$('.WeiLaiBrandIntroductionInfo').html(WeiLaiBrandIntroductionInfo[language])
$('.WeiLaiCorevalueTitle').html(WeiLaiCorevalueTitle[language]);
$('.WeiLaiCorevalueIntroduction').html(WeiLaiCorevalueIntroduction[language])
$('.WeiLaiDifference').html(WeiLaiDifference[language])
$('.WeiLaiDifference1').html(WeiLaiDifference1[language])
$('.WeiLaiDifference2').html(WeiLaiDifference2[language])
$('.WeiLaiDifference3').html(WeiLaiDifference3[language])
$('.WeiLaiDifference4').html(WeiLaiDifference4[language])
$('.WeiLaiDifference5').html(WeiLaiDifference5[language])
$('.WeiLaiDifference6').html(WeiLaiDifference6[language])
$('.WeiLaiDifference5Info').html(WeiLaiDifference5Info[language])
$('.WeiLaiDifference6Info').html(WeiLaiDifference6Info[language])
$('.commonLvyue1').html(commonLvyue1[language]);
$('.Leadership').html(Leadership[language]);
$('.TalentRecruitment').html(TalentRecruitment[language]);
$('.WeiLaiBuildingaboutfbType1').html(homePageSwiperFourDesignideaInfo2[language]);
$('.WeiLaiBuildingaboutfbType3').html(homePageSwiperFourTourismVacationSocialBusiness[language]);
$('.floralReservation').html(floralReservation[language]);
$('.commonBaina').html(commonBaina[language]);
$('.commonBanlan').html(commonBanlan[language]);



/** WEBPACK FOOTER **
 ** ./src/js/tanchenLanguage.js
 **/